import { render, staticRenderFns } from "./CreateSocialProgram.vue?vue&type=template&id=4db786e2"
import script from "./CreateSocialProgram.ts?vue&type=script&lang=ts&external"
export * from "./CreateSocialProgram.ts?vue&type=script&lang=ts&external"
import style0 from "./CreateSocialProgram.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports